<template>
  <div id="app" v-touch:right="onSwipeLeft">
    <!-- 头部 -->
    <HeaderTop />

    <!-- 左侧导航 -->
    <leftNav
      v-show="show_left_nav"
      class="top-right-menu"
      @ListenChild="tabChange"
    />

    <!-- 视图窗口 -->
    <router-view id="vier_port" />

    <!-- 登录弹窗 -->
    <div v-show="is_show_wrap" class="login-wrap" @click="is_show_wrap = false">
      <div v-show="is_show_login" class="login-form" @click.stop="a = 1">
        <!-- <img src="./assets/images/logo/logo.png" class="lr_logo" alt="" /> -->

        <div class="lg-title">
          <div>
            <svg
              t="1715509209132"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2503"
              width="20"
              height="20"
            >
              <path
                d="M512.0181274414062 140.7236328125c-125.93957519531247 0-228.48156738281247 102.50326538085938-228.48156738281247 228.48074340820312 0 125.90167236328126 102.46701049804688 228.44448852539062 228.48156738281247 228.44448852539062 125.97665405273438 0 228.517822265625-102.54199218749999 228.517822265625-228.44448852539062 0-125.97747802734375-102.54116821289061-228.48074340820312-228.517822265625-228.48074340820312z"
                fill="#FFF"
                p-id="2504"
              ></path>
              <path
                d="M688.11962890625 592.4355773925781c-48.68206787109375 38.48208618164063-109.30682373046875 62.32461547851563-176.10150146484375 62.32461547851563-66.79550170898438 0-127.38153076171872-23.915863037109375-176.17565917968753-62.32461547851563C243.4666748046875 651.2484130859374 179.14804077148432 754.5303344726562 170.31338500976562 874.1483764648438c32.343475341796875 4.396728515625001 89.89892578124999 9.127990722656248 172.03436279296875 9.127990722656248h339.1916198730469c82.17333984375 0 139.7650451660156-4.731262207031249 172.14724731445312-9.127990722656248-8.762145996093748-119.69384765625-73.07995605468749-222.89996337890622-165.5669860839844-281.71279907226557z"
                fill="#FFF"
                p-id="2505"
              ></path>
            </svg>
          </div>

          Login
        </div>

        <div class="item mt">
          <span class="icon">
            <van-icon name="user" class="ricon" />
          </span>
          <span v-show="data.username.length == 0" class="inputno">*</span>
          <input
            v-model.trim="data.username"
            type="text"
            class="inp"
            :placeholder="'Nome de Usuário'"
          />
          <van-icon
            v-if="data.username.length > 0"
            name="close"
            class="pwdeye"
            @click="data.username = ''"
          />
        </div>
        <div v-if="data.username.length == 0" class="LRnotice"></div>
        <div
          class="LRnotice"
          v-else-if="data.username.length < 4 || data.username.length > 16"
        >
          4-16 caráter bit, suporte em inglês/números
        </div>
        <div v-else class="LRnotice"></div>
        <div class="item">
          <span class="icon">
            <van-icon name="lock" class="ricon" />
          </span>
          <span v-show="data.password.length == 0" class="inputno">*</span>
          <input
            v-model.trim="data.password"
            type="password"
            class="inp"
            :placeholder="'Senha'"
            id="password0"
          />
          <van-icon
            v-if="data.password.length > 0"
            name="close"
            class="pwdeye"
            @click="data.password = ''"
          />
          <van-icon
            v-if="showPwd[0]"
            name="eye-o"
            class="pwdeye colorc"
            @click="ShowPwd(0)"
          />
          <van-icon
            v-else
            name="closed-eye"
            class="pwdeye"
            @click="ShowPwd(0)"
          />
        </div>
        <div v-if="data.password.length == 0" class="LRnotice"></div>
        <div
          class="LRnotice"
          v-else-if="data.password.length < 6 || data.password.length > 18"
        >
          6-18 caracteres, incluindo pelo menos números ou letras
        </div>
        <div v-else class="LRnotice"></div>
        <div class="remeber">
          <div class="rem-left">
            <van-checkbox
              v-model="checked[0]"
              shape="square"
              icon-size="16px"
              checked-color="#04be02"
            ></van-checkbox>
            <span>Lembrar Senha</span>
          </div>
          <div class="rem-right">Esqueceu a Senha?</div>
        </div>

        <div class="lg-btn" @click="submit_login()">Login</div>

        <div class="loginrow">
          <!-- {{ $t("还没账号?") }} -->
          <span class="signup">Suporte</span>
          <span class="signup">Jogar Grátis</span>
          <span class="signup" @click.stop="register()"
            >Registra uma Conta</span
          >
        </div>
        <div class="loginrow" style="font-weight: 100">
          ——
          <span>Outros métodos de início de sessãos</span>
          ——
        </div>
        <div class="lrgg">
          <img src="./assets/images/common/google.png" />
        </div>

        <img
          src="./assets/images/common/close.png"
          class="close_btn1"
          alt=""
          @click="closeWindow()"
        />
      </div>

      <!-- 注册 -->
      <div v-show="is_show_register" class="login-form" @click.stop="a = 1">
        <!-- <img src="./assets/images/logo/logo.png" class="lr_logo" alt="" /> -->

        <div class="lg-title">Registro</div>

        <div class="item mt">
          <span class="icon">
            <van-icon name="user" class="ricon" />
          </span>
          <span v-show="register_data.mobile.length == 0" class="inputno"
            >*</span
          >
          <input
            v-model.trim="register_data.mobile"
            type="text"
            class="inp"
            :placeholder="'Nome de Usuário'"
          />
        </div>
        <div v-if="register_data.mobile.length == 0" class="LRnotice"></div>
        <div
          class="LRnotice"
          v-else-if="
            register_data.mobile.length < 5 || register_data.mobile.length > 16
          "
        >
          4-16 caráter bit, suporte em inglês/númeross
        </div>
        <div v-else class="LRnotice"></div>
        <div class="item">
          <span class="icon">
            <van-icon name="lock" class="ricon" />
          </span>
          <span v-show="register_data.password.length == 0" class="inputno"
            >*</span
          >
          <input
            v-model.trim="register_data.password"
            type="password"
            class="inp"
            :placeholder="$t('请设置登录密码')"
            id="password1"
          />
          <van-icon
            v-show="showPwd[1]"
            name="eye-o"
            class="pwdeye"
            @click="ShowPwd(1)"
          />
          <van-icon
            v-show="!showPwd[1]"
            name="closed-eye"
            class="pwdeye"
            @click="ShowPwd(1)"
          />
        </div>
        <div v-if="register_data.password.length == 0" class="LRnotice"></div>
        <div
          class="LRnotice"
          v-else-if="
            register_data.password.length < 6 ||
            register_data.password.length > 18
          "
        >
          A senha tem de 6 a 18 caracteres
        </div>
        <div v-else class="LRnotice"></div>
        <div class="streng-box">
          <span class="forSpan">Força</span>
          <div class="schedule">
            <span class="bg-span p-a"></span>
            <span class="bg-span p-b"></span>
            <span class="bg-span p-c"></span>
            <span class="bg-span p-d"></span>
            <span v-if="strength >= 1" class="low p-a"></span>
            <span v-if="strength >= 2" class="centre p-b"></span>
            <span v-if="strength >= 3" class="tall p-c"></span>
            <span v-if="strength >= 3" class="tall p-d"></span>
          </div>

            
        </div>

        <div class="item">
          <span class="icon">
            <van-icon name="lock" class="ricon" />
          </span>
          <span v-show="register_data.spassword.length == 0" class="inputno"
            >*</span
          >
          <input
            v-model.trim="register_data.spassword"
            type="password"
            class="inp"
            :placeholder="$t('重复登录密码')"
            id="password2"
          />
          <van-icon
            v-show="showPwd[2]"
            name="eye-o"
            class="pwdeye"
            @click="ShowPwd(2)"
          />
          <van-icon
            v-show="!showPwd[2]"
            name="closed-eye"
            class="pwdeye"
            @click="ShowPwd(2)"
          />
        </div>

        <div class="item mt">
          <span class="icon">
            <i class="ricon el-icon-postcard" />
          </span>
          <input
            v-model.trim="register_data.real_name"
            type="text"
            class="inp"
            :placeholder="'Nome completo'"
          />
        </div>

        <div class="remeber2">
          <van-checkbox
            v-model="checked[1]"
            shape="square"
            icon-size="16px"
            checked-color="#04be02"
          ></van-checkbox>
          <span>Tenho 18 anos, li e concordo com </span>
          <span class="colorc"> 《Contrato do usuário》</span>
        </div>

        <div class="now-btn" @click="submit_reigster">Registro</div>
        <div class="loginrow">
          <span class="signup">Suporte</span>
          <span class="signup">Jogar Grátis</span>
          <span class="signup" @click.stop="login()">Login Agora</span>
        </div>
        <div class="loginrow" style="font-weight: 100">
          ——
          <span>Outros métodos de início de sessãos</span>
          ——
        </div>
        <div class="lrgg">
          <img src="./assets/images/common/google.png" />
        </div>
        <img
          src="./assets/images/common/close.png"
          class="close_btn"
          alt=""
          @click="closeWindow()"
        />
      </div>
    </div>

    <!-- 底部导航 -->
    <div v-if="isShowFt">
      <FtNav />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
import { Icon, Popover, Checkbox, CheckboxGroup } from "vant";
import router from "./router";
import Fetch from "./utils/fetch";
import FtNav from "./components/footer_nav/footer_nav.vue";
import leftNav from "./components/leftNav.vue";
import HeaderTop from "./components/header.vue";

Vue.use(Notify).use(Icon).use(Popover).use(Checkbox).use(CheckboxGroup);
export default {
  name: "App",
  components: {
    FtNav,
    leftNav,
    HeaderTop,
  },
  data() {
    return {
      isShowFt: true,
      checked: [true, true],
      showPwd: [false, false, false],
      user_balance: localStorage.getItem("user_balance") || 0,
      is_show_wrap: false,
      is_show_login: false,
      is_show_register: false,
      sync_timer: null,
      showUserinfo: false,
      showUser: false,
      show_left_nav: false,
      app: {},
      data: {
        username: "",
        password: "",
      },
      register_data: {
        password: "",
        spassword: "",
        mobile: "",
        invitation_code: localStorage.getItem("code") || null,
        sms: "",
        real_name: "",
      },
    };
  },
  watch: {
    user_balance: function (newv) {
      localStorage.setItem("user_balance", newv);
    },
    // isShowFt: function () {
    //   if (document.documentElement.clientWidth > 900) {
    //     this.isShowFt = true;
    //   }
    // },
    $route: function (r) {
      if (
        r.path == "/subgame" ||
        r.path == "/vip" ||
        r.path == "/share" ||
        r.path == "/gameRecord" ||
        r.path == "/betReward" ||
        r.path == "/rechargeRecord" ||
        r.path == "/withdrawRecord" ||
        r.path == "/record"
      ) {
        this.isShowFt = false;
      } else {
        this.isShowFt = true;
      }
    },
  },
  computed: {
    strength() {
      //验证密码强度的函数
      var val = this.register_data.password || "";
      var lv = 0;
      if (val.match(/[a-z]/g)) {
        lv++;
      } //验证是否包含字母
      if (val.match(/[0-9]/g)) {
        lv++;
      } // 验证是否包含数字
      if (val.match(/(.[^a-z0-9])/g)) {
        lv++;
      } //验证是否包含字母，数字，字符
      if (val.length > 12) {
        lv++;
      }
      if (lv > 3) {
        lv = 4;
      }
      return lv;
    },
  },
  updated() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted() {
    let _this = this;
    // if (document.documentElement.clientWidth > 900) {
    //   _this.isShowFt = true;
    // }
    // window.onresize = function () {
    //   console.log("宽度", document.documentElement.clientWidth);
    //   console.log("高度", document.documentElement.clientHeight);
    //   if (document.documentElement.clientWidth > 900) {
    //     _this.isShowFt = true;
    //     console.log(_this.isShowFt);
    //   }
    // };
  },
  created() {
    let _this = this;
    router.beforeEach((to, from, next) => {
      let token = localStorage.getItem("token");
      if (!token) {
        _this.login();
        return false;
      }
      return next();
    });
    let param = this.getUrlParams();
    console.log(param["id"]);
    if (param["id"]) {
      if (param["id"].length == 6) {
        this.register_data.invitation_code = param["id"];
      } else {
        let idx = param["id"].indexOf("#");
        let invi_code = param["id"].substring(0, idx);
        this.register_data.invitation_code = invi_code;
      }
      localStorage.setItem("code", this.register_data.invitation_code);
      //console.log(localStorage.getItem("code"))
    }
  },
  methods: {
    ShowPwd(i) {
      var password = document.getElementById("password" + i);
      if (password.type == "password") {
        password.type = "text";
        this.showPwd[i] = true;
      } else {
        password.type = "password";
        this.showPwd[i] = false;
        //console.log(1);
      }
    },
    getUrlParams() {
      let url = window.location.href;
      if (url.indexOf("?") == -1) return {};
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split("?")[1];
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      let paramsArr = urlStr.split("&");
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },
    submit_reigster() {
      this.register_data.invitation_code = localStorage.getItem("code")
        ? localStorage.getItem("code")
        : null;
      if (!this.register_data.mobile) {
        this.$notify.warning({
          title: this.$store.state.config.site_name,
          message: this.$t("手机号码不能为空"),
        });
        return false;
      }
      if (
        !this.register_data.password ||
        this.register_data.password.length < 6
      ) {
        this.$notify.warning({
          title: this.$store.state.config.site_name,
          message: this.$t("密码长度为6-18位"),
        });
        return false;
      }
      if (this.register_data.password != this.register_data.spassword) {
        this.$notify.warning({
          title: this.$store.state.config.site_name,
          message: this.$t("两次密码不一致"),
        });
        return false;
      }
      this.register_data["url"] = window.location.href;
      this.register_data.mobile = this.register_data.mobile.replace(
        new RegExp("[+]", "gm"),
        ""
      );
      Fetch("/user/register", this.register_data)
        .then((res) => {
          //console.log(res);
          if (res.code == 1) {
            //注册成功
            this.$notify.success({
              title: this.$store.state.config.site_name,
              message: this.$t("注册成功"),
            });
            localStorage.setItem("login_username", this.register_data.mobile);
            setTimeout(() => {
              this.login();
            }, 3000);
          } else {
            this.$notify.warning({
              title: this.$store.state.config.site_name,
              message: res.msg,
            });
          }
        })
        .catch((e) => {
          this.$notify.warning({
            title: this.$store.state.config.site_name,
            message: this.$t("系统繁忙,请稍后再尝试"),
          });
          return false;
        });
    },
    submit_login() {
      if (!this.data.username) {
        this.$notify.warning({
          title: this.$store.state.config.site_name,
          message: this.$t("请输入正确的手机号码"),
        });
        return;
      }
      if (!this.data.password) {
        this.$notify.warning({
          title: this.$store.state.config.site_name,
          message: this.$t("密码为6-18位"),
        });
        return;
      }
      this.data.username = this.data.username.replace(
        new RegExp("[+]", "gm"),
        ""
      );
      Fetch("/user/login", {
        account: this.data.username,
        password: this.data.password,
      }).then((res) => {
        //登录失败
        if (res.code == 0) {
          this.$notify.warning({
            title: this.$store.state.config.site_name,
            message: res.msg,
          });
        } else {
          if (res.data.userinfo.token) {
            localStorage.setItem("token", res.data.userinfo.token);
            localStorage.setItem("user_balance", res.data.userinfo.money);
          }
          this.$notify.success({
            title: this.$store.state.config.site_name,
            message: this.$t("登录成功"),
          });
          //保存账户密码
          localStorage.setItem("login_username", this.data.username);
          localStorage.setItem("login_password", this.data.password);
          //跳转到首页
          setTimeout(() => {
            window.location.href = "/";
          }, 400);
        }
      });
    },
    login() {
      this.data.username = localStorage.getItem("login_username")
        ? localStorage.getItem("login_username")
        : "";
      this.is_show_wrap = true;
      this.is_show_login = true;
      this.is_show_register = false;
      return;
    },
    register() {
      this.is_show_wrap = true;
      this.is_show_login = false;
      this.is_show_register = true;
      return;
    },
    closeWindow() {
      this.is_show_wrap = false;
      this.is_show_login = false;
      this.is_show_register = false;
    },
    tabChange(v) {
      // console.log(v);
      this.nav_active = v;
      if (v == 0) {
        this.getGameList();
      }

      if (v == 1) {
        this.all_game_list = [];
        let allGames = [];
        this.all_game_list_bak.forEach((item) => {
          item.game_list.forEach((game) => {
            if (game.origin == "PG") {
              allGames.push(game);
            }
          });
        });
        this.all_game_list.push({
          origin: "PG Slots",
          game_list: allGames,
        });
      }
      if (v == 2) {
        this.all_game_list = [];
        let allGames = [];
        this.all_game_list_bak.forEach((item) => {
          item.game_list.forEach((game) => {
            if (game.origin == "TADA") {
              allGames.push(game);
            }
          });
        });
        this.all_game_list.push({
          origin: "TADA Slots",
          game_list: allGames,
        });
      }
      if (v == 3) {
        let localGames = localStorage.getItem("local_game_list");
        if (!localGames) {
          let json_obj = { PG: [], JDB: [], TADA: [] };
          localStorage.setItem("local_game_list", JSON.stringify(json_obj));
          localGames = localStorage.getItem("local_game_list");
        }
        Fetch("/Game/getGameById", JSON.parse(localGames)).then((res) => {
          let _this = this;
          this.all_game_list = res.data;
          this.all_game_list_bak = res.data;
          this.max_show_array = [];
          res.data.forEach(() => {
            _this.max_show_array.push(6);
          });
        });
      }
    },

    changeBalance(val) {
      this.user_balance = val;
    },
    onSwipeLeft(even, start, end) {
      //console.log(window.location.href);

      if (window.location.href.indexOf("signature")) {
        return false;
      }
      if (end["X"] - start["X"] > 60) {
        this.$router.go(-1);
      }
    },
    bigNumeber(str) {
      var str = str.toString();
      var strs = str.split(".");
      var s1 = strs[0] || 0;
      var s2 = strs[1] || "00";
      return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
    },
  },
};
</script>
<style lang="less">
@import "./assets/css/login&register.less";
@import "./assets/css/phone.css";
@import "./assets/css/pad.css";
@import "./assets/css/pc.less";
@import "./assets/css/default.less";
@import "./assets/css/variables.less";

@headerHeight: 1.2rem;

html,
body {
  // width: 100%;
  // height: 100%;
  overflow-y: scroll;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB,
    Microsoft Yahei, sans-serif !important;
  user-select: none !important;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0;
  height: 0;
}
html {
  background-color: @third-color;
}
body {
  max-width: @maxWidth;
  height: 100vh;
  margin: 0 auto !important;
  position: relative;
  // overflow: hidden;
}

#app {
  min-height: 100%;
  height: auto;
  width: 100%;
  overflow-x: hidden;
  background-image: url("./assets/images/index/bg_pattern_tile.webp");
  background-color: @secondary-color;
}

.el-message-box__header {
  background-image: url("./assets/images/logo/v5.png");
  background-repeat: no-repeat;
  background-size: 60%;
  background-position: center;
  height: 0.5rem;
  width: 1.5rem;
  margin: auto;
}

.lrgg img {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0.2rem;
  background: #fff;
  border-radius: 50%;
}
</style>
